export enum SORT_KEY {
  CREATED = "createdAt",
  UPDATED = "updatedAt",
  PRICE = "price",
  TITLE = "title",
  ATTRIBUTE = "categoryData",
}
